import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';
import { getCurrentAccount } from '../api-query/customer'

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

async function getAnualSavings(session: any) {
    if(!session?.accessToken || session?.expiryMs < Date.now()) {
        throw new Error('Session expired')
    }
    const { siteId } = getCurrentAccount();
    if(!siteId) {
        throw new Error('Loading...')
    }
    const res = await fetch(`${BFF_BASE_URL}/v1/savings/annual/reports`,
        {
            method: 'POST',
            body: JSON.stringify({ siteId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session?.accessToken}`,
                'x-id': `${session?.idToken}`,
                'x-session-id': session?.sessionId || 'x-session-id',
                'x-correlation-id': uuidv4()
            }
        }
    );
    
    if (!res.ok) {
        throw new Error((await res.json()).message);
    }
    return (await res.json())
}

export const useGetAnualSavings = (session: any) => {
    const { error: errorSavingsReports, 
            data: annualSavingsReports } = useQuery({
            queryKey: ['AnnualSavingsReports'], // key must be unique
            queryFn: ()=>getAnualSavings(session),
            staleTime: (60000 * 600 )
    })
    return { errorSavingsReports, annualSavingsReports }
};


